import React from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { IUser } from '../../../libraries/users';
import { Language } from '../../languages/languageHandler';
import './styles.scss';

interface UserSectionProps {
  users: IUser[];
  lang: Language;
}

const UserSection = ({ users, lang }: UserSectionProps) => {
  return (
    <>
      <Container>
        <Row className="mb-2">
          <Col>
            <div className="distribution-details-table">
              <Table size="sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{lang.GLOBAL_NAME}</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map(user => (
                    <tr key={user.uid}>
                      <td>{user.uid}</td>
                      <td>{user.name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UserSection;
